<sw-page class="topdata-es-mining-stopword-list-page">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onAddStopword">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.buttonAdd') }}
        </sw-button>
    </template>

    <template #content>
        <sw-card class="topdata-es-mining-stopword-filters" :isLoading="false">
            <sw-container columns="1fr 1fr 1fr" gap="16px" align="end">
                <sw-simple-search-field
                    v-model:value="term"
                    @search-term-change="onSearch"
                    :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.placeholderSearch')"
                />
                <sw-single-select
                    v-model:value="languageFilter"
                    :options="languageOptions"
                    :label="$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.columnLanguage')"
                    :show-clearable="true"
                    @update:value="onLanguageFilterChange"
                />
                <sw-single-select
                    v-model:value="activeFilter"
                    :options="activeOptions"
                    :label="$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.columnActive')"
                    :show-clearable="true"
                    @update:value="onActiveFilterChange"
                />
            </sw-container>
        </sw-card>

        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-es-mining-stopword"
            :show-settings="true"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="false"
            :allow-delete="true"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-languageId="{ item }">
                {{ getLanguageLabel(item.languageId) }}
            </template>

            <template #column-active="{ item }">
                <sw-label :variant="item.active ? 'success' : 'default'" size="medium">
                    {{ item.active
                        ? $tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.activeYes')
                        : $tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.activeNo') }}
                </sw-label>
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago :date="item.createdAt" :date-time-format="{ month: '2-digit', day: '2-digit' }" />
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="onEditStopword(item)">
                    {{ $tc('global.default.edit') }}
                </sw-context-menu-item>
                <sw-context-menu-item variant="danger" @click="onShowDeleteModal(item)">
                    {{ $tc('global.default.delete') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <sw-confirm-modal
            v-if="showDeleteModal"
            :title="$tc('global.default.delete')"
            :text="deleteConfirmText"
            :confirmButtonVariant="'danger'"
            @confirm="onConfirmDelete"
            @close="onCloseDeleteModal"
            @cancel="onCloseDeleteModal"
        />

        <topdata-es-mining-stopword-form
            v-if="activeModal"
            :entity="currentEntity"
            :repository="repository"
            @save="onCloseModal"
            @cancel="onCloseModal"
        />
    </template>
</sw-page>
